import gql from 'graphql-tag';

export default gql`
  mutation orderAccept($id: ID!, $note: String) {
    orderAccept(id: $id, note: $note) {
      userErrors {
        field
        message
      }
      success
      order {
        id
        total
        status
      }
    }
  }
`;
